<template>
  <div class="events">
    <post-back :title="tr.main_events" />
      <div class="containers events-container">
        <posts-grid :posts="events" :total="total"/>
      </div>
      
  </div>
</template>

<script>
import PostsGrid from "./posts-grid.vue";
export default {
  components:{PostsGrid},
  name: 'events',
  computed:{
    seo(){return {title:this.trRaw.main_events, description: this.trRaw.events_meta_description}},
    events(){
            let { lang } = this.$store.state;

      return this.$store.getters.events.filter(p => { return p.content[lang]&&p.content[lang].enabled });},
    total(){
      let { lang } = this.$store.state;
      return this.$store.getters.events.filter(p => { return p.content[lang]&&p.content[lang].enabled }).length;
    }
  }
}
</script>

<style lang="css" scoped>
.events-container{
  padding:30px 0;
}
</style>